import { Clock } from "lucide-react";
import { SUCCESS_STORIES } from "../data/automationData";

export const SuccessStories = () => {
  return (
    <section
      className="bg-primary text-primary-foreground py-20 md:py-28"
      data-testid="success-stories-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-accent mb-3">
          Negocios reales, horas reales ahorradas
        </p>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight mb-14 max-w-2xl">
          Ellos también dudaban. Ahora no se imaginan sin IA.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SUCCESS_STORIES.map((s, i) => (
            <article
              key={s.name}
              className="bg-primary-foreground/5 border border-primary-foreground/10 rounded-2xl overflow-hidden flex flex-col"
              data-testid={`success-story-${i}`}
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-4">
                  <span className="text-xs font-semibold bg-accent text-accent-foreground px-2.5 py-1 rounded-full">
                    {s.type}
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-foreground/70">
                    <Clock className="h-3.5 w-3.5" /> {s.hoursSaved} hrs/sem ahorradas
                  </span>
                </div>
                <p className="text-sm leading-relaxed text-primary-foreground/90 flex-1">
                  "{s.quote}"
                </p>
                <div className="mt-5 pt-5 border-t border-primary-foreground/10">
                  <p className="font-heading font-semibold">{s.name}</p>
                  <p className="text-sm text-primary-foreground/60">{s.person}</p>
                  <p className="text-sm font-semibold text-accent mt-2">{s.metric}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
